/* tslint:disable */
/* eslint-disable */
/**
 * Jobs API
 * Backend de bolsa de trabajo para alumno, empresa y admin.  Pantallas de Alumno [P_A_xx]   https://app.axure.cloud/app/project/5t0fsq/overview  Pantallas de empresa [P_E_xx]    https://app.axure.cloud/app/project/jcj3w8/overview
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Sectores
 * @export
 * @interface BusinessSectors
 */
export interface BusinessSectors {
    /**
     * 
     * @type {number}
     * @memberof BusinessSectors
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof BusinessSectors
     */
    name?: string;
}

export function BusinessSectorsFromJSON(json: any): BusinessSectors {
    return BusinessSectorsFromJSONTyped(json, false);
}

export function BusinessSectorsFromJSONTyped(json: any, ignoreDiscriminator: boolean): BusinessSectors {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
    };
}

export function BusinessSectorsToJSON(value?: BusinessSectors | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
    };
}


